export const categoryFacetSortCriteria = [
    'alphanumeric',
    'occurrences',
];
